import { render, staticRenderFns } from "./FormattedProductValue.vue?vue&type=template&id=a2c0d014"
import script from "./FormattedProductValue.js?vue&type=script&lang=js&external"
export * from "./FormattedProductValue.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports